export default "__VITE_ASSET__BjXuNFZQ__"